const actions = [
  "add",
  "edit",
  "details",
  "view",
  "create",
  "update",
  "delete",
  "all",
];

export const isItemActiveRecursive = (itemToCheck, currentPath) => {
  if (!itemToCheck) return false;

  // Normalize paths for comparison
  const itemPath = itemToCheck.path?.startsWith("/")
    ? itemToCheck.path
    : `/${itemToCheck.path}`;
  const normalizedCurrentPath = currentPath.startsWith("/")
    ? currentPath
    : `/${currentPath}`;

  // 1. Direct match
  if (itemPath === normalizedCurrentPath) return true;

  // 2. Check activePaths array if it exists
  if (
    itemToCheck.activePaths?.some((p) => {
      const normalizedP = p.startsWith("/") ? p : `/${p}`;
      return (
        normalizedCurrentPath === normalizedP ||
        normalizedCurrentPath.startsWith(normalizedP + "/")
      );
    })
  ) {
    return true;
  }

  // 3. Match for action routes with URL params (e.g., /sales/pricelist/edit/123)
  const pathSegments = normalizedCurrentPath.split("/").filter(Boolean);
  if (itemToCheck.path && pathSegments.length >= 2) {
    const potentialAction = pathSegments[pathSegments.length - 2];
    if (actions.includes(potentialAction)) {
      const basePath = "/" + pathSegments.slice(0, -1).join("/");
      if (itemPath === basePath) return true;

      const parentPath = "/" + pathSegments.slice(0, -2).join("/");
      if (itemPath === parentPath) return true;
    }

    const action = pathSegments[pathSegments.length - 1];
    if (actions.includes(action)) {
      const basePath = "/" + pathSegments.slice(0, -1).join("/");
      if (itemPath === basePath) return true;
    }
  }

  // 4. Check children recursively
  if (itemToCheck.childrens) {
    return itemToCheck.childrens.some((child) =>
      isItemActiveRecursive(child, normalizedCurrentPath)
    );
  }

  return false;
};
